import { sortSelectionsByName } from "../sortSelectionsByName";
import { sortSelectionsByOdd } from "../sortSelectionsByOdd";
export class OutrightSelectionSorter {
    constructor(options) {
        this.sortStrategies = {
            default: sortSelectionsByOdd
        };
        this.getSortStrategy = (sportId) => {
            return this.sortStrategies[sportId] || this.sortStrategies["default"];
        };
        this.addSortByNameForSportIds = (sportIds) => {
            const numericNameSort = sortSelectionsByName.bind(undefined, this.options.locale);
            sportIds.forEach(id => {
                this.sortStrategies[id] = numericNameSort;
            });
        };
        this.options = options;
        if (this.options.nameSortSportIds && this.options.locale) {
            this.addSortByNameForSportIds(this.options.nameSortSportIds);
        }
    }
}
//# sourceMappingURL=OutrightSelectionSorter.js.map